export enum E_DisplayType {
    DisplayNurse = "DisplayNurse",
    SmartDisplay = "SmartDisplay",
    NewStandard = "NewStandard",
}